import { curry } from 'ramda';
import type { BrowseCategory, BrowseCategorySlug } from './BrowseCategory';
import { browseCategorySlugFromCaesarMapper } from './BrowseCategory';

export const toCategoryLink = curry(
  (toLinkUrl: LinkUrlBuilder, browseCategory: BrowseCategory): CategoryLink => ({
    name: browseCategory.name,
    slug: browseCategorySlugFromCaesarMapper(browseCategory.slug),
    linkPath: toLinkUrl(browseCategorySlugFromCaesarMapper(browseCategory.slug)),
  }),
);

export type CategoryLink = {
  name: string;
  slug: BrowseCategorySlug;
  linkPath: string;
};

type LinkUrlBuilder = (slug: BrowseCategorySlug) => string;
